export class DocxPreviewError extends Error {}
